import './widgetSm.css';
import { Visibility } from '@material-ui/icons'

export default function WidgetSm() {
    return (
        <div className='widgetSm'>
            <span className='widgetSmTitle'>New Join Members</span>
            <ul className='widgetSmList'>
                <li className='widgetSmlistItem'>
                    <img src="https://picsum.photos/200" alt="" className='widgetSmImg' />
                    <div className="widgetSmUser">
                        <span className="widgetSmUsername">Anna Keller</span>
                        <span className="widgetSmUserTitle">Software Enginner</span>
                    </div>
                    <button className="widgetSmBuuton">
                        <Visibility className='widgetSmIcon' />
                        Display
                    </button>
                </li>
                <li className='widgetSmlistItem'>
                    <img src="https://picsum.photos/201" alt="" className='widgetSmImg' />
                    <div className="widgetSmUser">
                        <span className="widgetSmUsername">Anna Keller</span>
                        <span className="widgetSmUserTitle">Software Enginner</span>
                    </div>
                    <button className="widgetSmBuuton">
                        <Visibility className='widgetSmIcon' />
                        Display
                    </button>
                </li>
                <li className='widgetSmlistItem'>
                    <img src="https://picsum.photos/202" alt="" className='widgetSmImg' />
                    <div className="widgetSmUser">
                        <span className="widgetSmUsername">Anna Keller</span>
                        <span className="widgetSmUserTitle">Software Enginner</span>
                    </div>
                    <button className="widgetSmBuuton">
                        <Visibility className='widgetSmIcon' />
                        Display
                    </button>
                </li>
                <li className='widgetSmlistItem'>
                    <img src="https://picsum.photos/203" alt="" className='widgetSmImg' />
                    <div className="widgetSmUser">
                        <span className="widgetSmUsername">Anna Keller</span>
                        <span className="widgetSmUserTitle">Software Enginner</span>
                    </div>
                    <button className="widgetSmBuuton">
                        <Visibility className='widgetSmIcon' />
                        Display
                    </button>
                </li>
                <li className='widgetSmlistItem'>
                    <img src="https://picsum.photos/204" alt="" className='widgetSmImg' />
                    <div className="widgetSmUser">
                        <span className="widgetSmUsername">Anna Keller</span>
                        <span className="widgetSmUserTitle">Software Enginner</span>
                    </div>
                    <button className="widgetSmBuuton">
                        <Visibility className='widgetSmIcon' />
                        Display
                    </button>
                </li>
            </ul>
        </div>
    )
}
